<h2 mat-dialog-title>{{ 'crud-alert.missing_field' | translate }}</h2>
<div mat-dialog-content>
  <ul>
    <li *ngFor="let field of data.alertFields">{{ field }}</li>
  </ul>
</div>
